<template>
  <!-- 首页顶部区域按钮
         @author liuguisheng
         @date 2019-9-13
  -->
  <div class="index-wrap_button">
    <div class="index-wrap_group">
      <el-button type="text" @click="onClearAll">
        <i class="iconfont icondelete"></i>
        <span>清空</span>
      </el-button>
      <el-button type="text" :loading="previewLoading" @click="onPreview">
        <i class="iconfont iconpreview"></i>
        <span>预览</span>
      </el-button>
      <el-button type="text" @click="onSubmit">
        <i class="iconfont iconcommit"></i>
        <span>提交</span>
      </el-button>
      <el-button v-if="expandFunction === 'group'"
                 type="text" @click="onSaveDomain">
        <i class="iconfont iconsave"></i>
        <span>另存为组</span>
      </el-button>
      <el-button type="text" @click="onCreatCode">
        <i class="iconfont iconcode"></i>
        <span>生成代码</span>
      </el-button>
    </div>

    <!-- 预览弹层 -->
    <grace-dialog class="rice-preview-bridge"
                  ref="preview"
                  :dialog:visible.sync="formPreview.visible"
                  dialog:title="预览表单"
                  dialog:width= "100%"
                  :formData="previewsDate"
                  dialog:is="rice-preview-bridge">
                </grace-dialog>

    <!-- 生成代码 -->
    <grace-dialog :dialog:visible.sync="showHtmlCode.visible"
                  dialog:title="查看代码"
                  dialog:is="make-code-preview"
                  v-model="dialogManage(showHtmlCode).data">
                </grace-dialog>

    <!-- 分组保存 -->
    <grace-dialog v-model="dialogManage(saveDomain).data"
                  :dialog:visible.sync="saveDomain.visible"
                  dialog:width="570px"
                  dialog:title="分组保存"
                  dialog:is="domain-save-dialog"
                  @submit="submitSaveDomain"
                  @cancel="dialogManage(saveDomain).hide()">
                </grace-dialog>
    <!-- 清空二次确认弹层 -->
    <el-dialog title="清空"
                :visible.sync="clearConfirm.visible"
                width="384px"
                plugin-name="ElLeave">
      <span slot="leave-title">编辑很辛苦</span>
      <span slot="leave-auxiliary">确定要清空当前拖拽吗？</span>
      <i slot="leave-icon" class="el-icon-erp-kulian"></i>
      <template slot="footer">
        <el-button type="primary" @click="onClearConfirm">确认清空</el-button>
        <el-button type="cancel" @click="dialogManage(clearConfirm).hide()">取消</el-button>
      </template>
    </el-dialog>

  </div>
</template>
<script>
const packageConfig = require('../../../package.json');
/** 混入方法 ::: 
 *  @mixin mixFormMakeChild 表单编辑组件子级混入
 */
import { mixRiceIndexChild } from "@/mixins/rice_index/mix_rice_index_child.js";
/** 工具方法 ::: 
 *  @function generateCode 生成代码
 *  @function deepCopy 深拷贝
 *  @function dialogDefaultConfig 对话框默认配置
 *  @function dialogManage 对话框管理者
 */
import generateCode from "@/utils/generate_code.js";
import { deepCopy } from "@/utils/utils.js";
import { dialogDefaultConfig, dialogManage } from "@/utils/dialog_manage.js";


// 测试数据
// import {formList,pickList} from "@/test.js";

export default {
  name: "IndexButtonGroup",
  mixins: [ mixRiceIndexChild ],
  inject: ['itemManage'],
  data() {
    return {
      // 预览弹窗
      formPreview: dialogDefaultConfig(),
      // 保存模块弹框开关
      saveDomain: dialogDefaultConfig(),
      // 生成代码预览
      showHtmlCode: dialogDefaultConfig(),
      // 清空二次确认弹层
      clearConfirm: dialogDefaultConfig(),
      // 预览数据
      previewsDate: {},
      // 预览loading
      previewLoading: false
    };
  },
  methods: {
    dialogManage,
    /**
     * @description 点击清空打开确认弹层
     * @author liuguisheng
     * @return { void }
     * @event clearAll
     * @version 2019-9-13
     */
    onClearAll() {
      // 如果没有拖拽拦截并提示
      if(this.formList.length == 0) return this.$message({type: 'warning',message: '你还没有添加组件嗷┗|｀O′|┛ ~~'})
      // 打开二次确定弹层
      dialogManage(this.clearConfirm).show()
    },
    /**
     * @description 清空确认
     * @author liuguisheng
     * @return { void }
     * @version 2020-1-4
     */
    onClearConfirm () {
      // 清空面板并关闭弹层
      this.formListManager().emptyList();
      dialogManage(this.clearConfirm).hide()
    },
    /**
     * @description 预览
     * @author liuguisheng
     * @return { void }
     * @event preview
     * @version 2019-9-13
     * @updateInfo 2020-1-9 liuguisheng 添加变量字典配置
     */
    onPreview() {
      // 预览按钮loading
      if (this.previewLoading) return;
      this.previewLoading = true;

      // 分组组件列表
      let previewDomainList = deepCopy(this.domainList);
      // 编辑区表单项列表
      let previewsList = deepCopy(this.formList);
      // 事件字典
      let previewsEventMap = deepCopy(this.eventMap);
      // 表单项字典
      let previewsFormMap = deepCopy(this.formMap);
      // 变量字典
      let previewVariableMap = deepCopy(this.variableMap);

      // 更新传入预览组件的值
      this.previewsDate = { 
        version: packageConfig.version,
        itemManage: this.itemManage,
        domainList: previewDomainList,
        formList: previewsList, 
        eventMap: previewsEventMap, 
        formMap: previewsFormMap,
        variableMap: previewVariableMap

      }
      // 如果表单区有内容就只显示表单编辑区的表单模版
      if ((this.domainEditManager().getStatus() !== 'normal') || (previewsList.length > 0)) {
        Reflect.set(this.previewsDate, 'domainList', []);
      }

      // 打开弹层
      setTimeout(() => dialogManage(this.formPreview).show(), 10);
      // 关闭loading
      this.$refs['preview'].$on('hook:mounted', () => { this.previewLoading = false; })
    },
    /**
     * @description 保存模块
     * @author liuguisheng
     * @return { void }
     * @version 2019-9-13
     */
    onSaveDomain() {
      // 拖拽区没有表单项，不进行后边的操作
      if (this.formList.length === 0) return this.$message({type: 'warning', message: '你还没有选择组件哦'});
      // 显示保存模块弹窗
      dialogManage(this.saveDomain).show();
    },
    /**
     * @description 提交
     * @author liuguisheng
     * @return { void }
     * @event submit
     * @version 2019-9-22
     */
    onSubmit() {
      if (this.domainEditManager().getStatus() !== 'normal') return this.$message({type: 'warning', message: '还有未保存的模块哦'});
      this.$emit("submit");
    },
    /**
     * @description 生成代码
     * @author liuguisheng
     * @return void
     * @event creatCode
     * @version 2019-9-13
     */
    onCreatCode() {
      let htmlCode = generateCode(JSON.stringify(this.formList));
      dialogManage(this.showHtmlCode).show(htmlCode);
    },
    /** @name 保存模块组件
     *  @author 王汝鹏
     *  @version 2019-11-06
     */
    submitSaveDomain() {
      // 从保存模块弹窗中取出模块名称
      let domainName = dialogManage(this.saveDomain).data;

      // 判断 创建新的分组 还是 使用其它分组copy一个新分组?
      // if T 创建一个新分组
      // else 使用原来的分组copy一个新分组
      if (this.domainEditManager().getStatus() === 'normal') {
        // 生成/获取 模块配置数据
        let domainConfig = this.makeDomainConfig(domainName, this.formList);
        // 将新模块配置添加到模块组件列表
        this.domainList.push(domainConfig);
      } else {
        this.domainEditManager().saveAs(domainName);
      }

      // 清空拖拽区表单数据，清空表单激活项
      this.formList = [];
      this.formListManager().activeNode({}, []);
      // 关闭弹窗
      dialogManage(this.saveDomain).hide();
      // 传出保存分组组件事件
      this.$emit("saveDomain");
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Form/IndexButtonGroup.vue